import React, { Component } from 'react';

/**
 * Animate — wraps children with enter/exit CSS animations.
 * When `animKey` changes, plays the exit animation showing the OLD
 * children, then swaps to current children with the enter animation.
 *
 * When animKey has NOT changed, always renders live props.children
 * so that in-place updates (loading states, form errors, etc.) are
 * reflected immediately without needing an animation trigger.
 */
class Animate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // snapshot of children shown during exit animation only
            exitingChildren: null,
            animClass:       props.enter || 'ps-anim-slide-in-right',
            exiting:         false,
        };
        this.exitTimer = null;
    }

    componentDidUpdate(prevProps) {
        // Only animate when animKey actually changes
        if (prevProps.animKey === this.props.animKey) return;

        const { exit = 'ps-anim-slide-out-left', duration = 200 } = this.props;

        if (this.exitTimer) clearTimeout(this.exitTimer);

        // Snapshot the OLD children to display during the exit animation
        this.setState({
            exiting:         true,
            exitingChildren: prevProps.children,
            animClass:       exit,
        });

        this.exitTimer = setTimeout(() => {
            const { enter = 'ps-anim-slide-in-right' } = this.props;
            this.setState({
                exiting:         false,
                exitingChildren: null,
                animClass:       enter,
            });
            this.exitTimer = null;
        }, duration);
    }

    componentWillUnmount() {
        if (this.exitTimer) clearTimeout(this.exitTimer);
    }

    render() {
        const { className = '', style, children } = this.props;
        const { exiting, exitingChildren, animClass } = this.state;

        // During exit: show the OLD children snapshot with the exit animation.
        // At all other times: render live props.children so in-place updates
        // (spinners, error messages, etc.) are never stale.
        const displayed = exiting ? exitingChildren : children;

        return (
            <div className={`${animClass} ${className}`} style={style}>
                {displayed}
            </div>
        );
    }
}

export default Animate;
